import React, {useContext} from 'react';
import {OrderViewContext} from "./OrderViewContext";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {exportXLSXFile} from "../../utils/exportCSVFile";

function TableButtons(props) {

  const helper = useContext(OrderViewContext);
  const setData = helper.setData
  const data = helper.data

  const navigateTo = useNavigate()
  console.log(data)

  const handleExport = () => {
    if (data?.currentTableData && data?.tableData?.columns) {
      const headers = {};
      data.tableData.columns.forEach(col => {
        if (col.field && col.title) {
          headers[col.field] = col.title;
        }
      });

      exportXLSXFile(data.currentTableData, "OrderList", headers);
    } else {
      toast.error("داده‌ای برای خروجی وجود ندارد");
    }
  }

  return (<div>

    <div className={"d-flex"}>

      <button
        className={"theme1__btn theme1__btn__main"}
        onClick={() => {
          navigateTo('/OrdersSadan')
        }}
      >
        افزودن سفارش
      </button>
      <button
        className={"theme1__btn mx-2"}
        onClick={handleExport}
      >
        خروجی اکسل
      </button>
      {/*<button*/}
      {/*  className={"theme1__btn"}*/}
      {/*  onClick={() => {*/}


      {/*    if (data?.selectedRowId) {*/}
      {/*      navigateTo('/OrdersSadan',{state: {id: data?.selectedRowId}})*/}
      {/*    } else {*/}
      {/*    toast('برای ویرایش باید یک سطر را انتخاب کنید.')*/}

      {/*    }*/}
      {/*  }}*/}
      {/*>*/}
      {/*  ویرایش سفارش*/}
      {/*</button>*/}
    </div>

  </div>);
}

export default TableButtons;